import Vue from 'vue';
import VueI18n from 'vue-i18n';
import getBrowserLocale from '@/util/i18n/get-browser-locale';
import supportedLocalesInclude from '@/util/i18n/supported-locales';
// import supportedLocales from '@/config/supported-locales';
import en from '@/locales/en';
import it from '@/locales/it';

Vue.use(VueI18n);

/* function getLocaleMessages() {
  const messages = {};

  Object.keys(supportedLocales).forEach((locale) => {
    import(`@/locales/${locale}`).then((loadedMessage) =>
    { messages[locale] = loadedMessage.default; });
  });

  return messages;
} */

function getStartingLocale() {
  const browserLocale = getBrowserLocale.getBrowserLocale({ countryCodeOnly: true });

  if (supportedLocalesInclude.supportedLocalesInclude(browserLocale)) return browserLocale;

  return process.env.VUE_APP_I18N_LOCALE || 'en';
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    en,
    it,
  },
});
